import { default as indexMNuxCtLhnUMeta } from "/home/gpotter/projects/gitOfs/vue/ofsprojects/pages/add/[type]/[id]/index.vue?macro=true";
import { default as _91mode_93Kyl0quPIK4Meta } from "/home/gpotter/projects/gitOfs/vue/ofsprojects/pages/browser/[mode].vue?macro=true";
import { default as index5wRnB4QYpXMeta } from "/home/gpotter/projects/gitOfs/vue/ofsprojects/pages/index.vue?macro=true";
import { default as _91token_93wcYaIPb3yGMeta } from "/home/gpotter/projects/gitOfs/vue/ofsprojects/pages/initialize/[token].vue?macro=true";
import { default as loginRTps3RTQ32Meta } from "/home/gpotter/projects/gitOfs/vue/ofsprojects/pages/login.vue?macro=true";
import { default as indexC7fxbYC2y8Meta } from "/home/gpotter/projects/gitOfs/vue/ofsprojects/pages/projects/[project]/[folder]/index.vue?macro=true";
import { default as index54lOxcHKhSMeta } from "/home/gpotter/projects/gitOfs/vue/ofsprojects/pages/projects/[project]/index.vue?macro=true";
import { default as _91project_93NWMaPGK64CMeta } from "/home/gpotter/projects/gitOfs/vue/ofsprojects/pages/projects/[project].vue?macro=true";
export default [
  {
    name: "add-type-id",
    path: "/add/:type()/:id()",
    meta: indexMNuxCtLhnUMeta || {},
    component: () => import("/home/gpotter/projects/gitOfs/vue/ofsprojects/pages/add/[type]/[id]/index.vue")
  },
  {
    name: "browser-mode",
    path: "/browser/:mode()",
    component: () => import("/home/gpotter/projects/gitOfs/vue/ofsprojects/pages/browser/[mode].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/gpotter/projects/gitOfs/vue/ofsprojects/pages/index.vue")
  },
  {
    name: "initialize-token",
    path: "/initialize/:token()",
    component: () => import("/home/gpotter/projects/gitOfs/vue/ofsprojects/pages/initialize/[token].vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/home/gpotter/projects/gitOfs/vue/ofsprojects/pages/login.vue")
  },
  {
    name: _91project_93NWMaPGK64CMeta?.name,
    path: "/projects/:project()",
    component: () => import("/home/gpotter/projects/gitOfs/vue/ofsprojects/pages/projects/[project].vue"),
    children: [
  {
    name: "projects-project-folder",
    path: ":folder()",
    component: () => import("/home/gpotter/projects/gitOfs/vue/ofsprojects/pages/projects/[project]/[folder]/index.vue")
  },
  {
    name: "projects-project",
    path: "",
    component: () => import("/home/gpotter/projects/gitOfs/vue/ofsprojects/pages/projects/[project]/index.vue")
  }
]
  }
]